import {parseSubRoleName, RoleCode} from "@/utils/role-constant";

export default {
  computed: {
    roleNameTitle() {
      let roleName = parseSubRoleName(this.role);
      roleName = roleName === null ? "MSL" : roleName;
      return roleName;
    },
    nameLabel() {
      return this.role === RoleCode.Admin || this.role === RoleCode.Supervisor || this.role === RoleCode.TALead ? "HCP" : "Customer"; // ? "SE/CE" : "Customer";
    }
  }
}